import { ConfirmDialog } from "primereact/confirmdialog";
import React from "react";

const DeleteConfirmation = ({
  visible,
  onHide,
  message,
  accept,
  reject,
  acceptClassName,
  header,
}) => {
  return (
    <>
      <ConfirmDialog
        visible={visible}
        onHide={onHide}
        message={message}
        header={header ? header : "Confirmation de suppression"}
        icon="pi pi-info-circle"
        accept={accept}
        reject={reject}
        acceptLabel="Oui"
        rejectLabel="Non"
        defaultFocus="reject"
        acceptClassName={acceptClassName && acceptClassName}
      />
    </>
  );
};

export default DeleteConfirmation;
